module.exports = __webpack_public_path__ + "static/media/refund.425d63a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/refund.svg
// module id = 6347
// module chunks = 1